module.exports = __webpack_public_path__ + "media/images/webpage/hotels/108/plan2-3-e50923dfe71c9a4b7ca385267c980aa0.webp";